import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* eslint-disable @typescript-eslint/no-unused-expressions */
import { ExpandedTooltip, Icon } from '@livable/saas-react-components';
import { FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
// import { useTranslation } from 'react-i18next';
import { useDelay } from 'src/utils/hooks';
import { isValueNumber } from 'src/utils/typeValidators';
import useStyles from './styles';

// Note: future improvements add external error handler
export default function FinancialTextInput(_ref) {
  let disabled = _ref.disabled,
    inputLabel = _ref.inputLabel,
    handleInputChange = _ref.handleInputChange,
    infoMark = _ref.infoMark,
    _ref$infoMarkNullPadd = _ref.infoMarkNullPaddingMargin,
    infoMarkNullPaddingMargin = _ref$infoMarkNullPadd === void 0 ? true : _ref$infoMarkNullPadd,
    _ref$percentageSign = _ref.percentageSign,
    percentageSign = _ref$percentageSign === void 0 ? false : _ref$percentageSign,
    _ref$refresh = _ref.refresh,
    refresh = _ref$refresh === void 0 ? false : _ref$refresh,
    valueExt = _ref.valueExt,
    _ref$withAdorment = _ref.withAdorment,
    withAdorment = _ref$withAdorment === void 0 ? false : _ref$withAdorment,
    percentSignOnRight = _ref.percentSignOnRight;
  // const { t } = useTranslation();
  const classes = useStyles();
  const _useState = useState(valueExt !== null && isValueNumber(valueExt) ? Number(valueExt).toFixed(2) : valueExt),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  const update = v => handleInputChange && handleInputChange(isValueNumber(v) ? Number(v) : null);
  useEffect(() => {
    if (refresh) setValue(valueExt !== null && isValueNumber(valueExt) ? Number(valueExt).toFixed(2) : valueExt);
  }, [refresh, valueExt]);
  useDelay(() => update(value), [value], 1000);
  const handleChange = e => setValue(e.target.value);
  return withAdorment ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: inputLabel
  }, inputLabel), /*#__PURE__*/React.createElement(OutlinedInput, {
    disabled: disabled,
    id: 'inputLabel',
    label: inputLabel,
    type: "string",
    placeholder: "Not set",
    startAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "start"
    }, percentageSign ? !percentSignOnRight ? '%' : '' : '$'),
    endAdornment: !!infoMark ? /*#__PURE__*/React.createElement(InputAdornment, {
      position: "end",
      type: "infoTooltip",
      className: infoMarkNullPaddingMargin && classes.endAdorment
    }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
      type: "grey",
      title: infoMark,
      placement: "top"
    }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
      type: "question"
    })))) : percentSignOnRight ? /*#__PURE__*/React.createElement(InputAdornment, {
      position: "end"
    }, percentageSign ? '%' : '') : null,
    value: value,
    onKeyPress: event => {
      if (!/[0-9]|[.]/.test(event.key)) {
        event.preventDefault();
      }
    },
    onChange: e => {
      if (!/^\d+([.]\d{0,2})?$|^$/.test(e.target.value)) return;
      handleChange(event);
    }
  }))) : /*#__PURE__*/React.createElement(TextField, {
    label: inputLabel,
    variant: "outlined",
    value: value,
    onKeyPress: event => {
      if (!/[0-9]|[.,]/.test(event.key)) {
        event.preventDefault();
      }
    },
    onChange: e => {
      if (!/^\d+([.,]\d{0,2})?$|^$/.test(e.target.value)) return;
      handleChange(event);
    }
  });
}